import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {IpopConfiguration} from '../../../../../model/ipop-configuration.model';

@Component({
    selector: 'auto-private-offers',
    templateUrl: './private-offers.component.html',
    styleUrls: ['./private-offers.component.scss'],
    standalone: false
})
export class PrivateOffersComponent implements OnInit, OnChanges {
  @Input() data: IpopConfiguration | null = null;
  @Output() formGroupInitialized = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      includePrivateOffersInExternalAdvertising: [false, Validators.required],
      unlockPrivateOffersEnabled: [false, Validators.required],
      displaySavingsMessage: [true, Validators.required],
      savingsMessage: ['Instant Savings Unlocked', [Validators.required, Validators.maxLength(255)]],
      savingsMessageBackgroundColor: ['#DDE9E2', [Validators.required, Validators.maxLength(255)]]
    });
    this.formGroupInitialized.emit(this.form);
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasIncoming = !!this.data && !!this.form;
    if (hasIncoming) {
      let displaySavingsMessage = true;
      let savingsMessage = 'Instant Savings Unlocked';
      let savingsMessageBackgroundColor = '#DDE9E2';

      if (this.data.displaySavingsMessage === false) {
        displaySavingsMessage = false;
      }

      const incomingSavingsMessage = this.data.savingsMessage;
      if (typeof incomingSavingsMessage === 'string') {
        const trimmed = incomingSavingsMessage.trim();
        if (trimmed !== '') {
          savingsMessage = trimmed;
        }
      }

      const incomingSavingsMessageBackgroundColor = this.data.savingsMessageBackgroundColor;
      if (typeof incomingSavingsMessageBackgroundColor === 'string') {
        const trimmed = incomingSavingsMessageBackgroundColor.trim();
        if (trimmed !== '') {
          savingsMessageBackgroundColor = trimmed;
        }
      }

      this.form.patchValue({
        includePrivateOffersInExternalAdvertising: !!this.data.includePrivateOffersInExternalAdvertising,
        unlockPrivateOffersEnabled: !!this.data.unlockPrivateOffersEnabled,
        displaySavingsMessage: displaySavingsMessage,
        savingsMessage: savingsMessage,
        savingsMessageBackgroundColor: savingsMessageBackgroundColor
      }, { emitEvent: false });
      this.form.markAsPristine();
    }
  }
}
